// src/Lexcallangel/angel.js
import React, { useEffect, useRef, useState } from "react";
import { FiVolume2, FiVolumeX } from "react-icons/fi";
import MiniGLBViewer from "../pages/Spaceship";

export default function AngelWrapper({ children }) {
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [volume, setVolume] = useState(0.05);

  // 初始化音频、循环播放
  useEffect(() => {
    const audio = new Audio("/sounds/call.mp3");
    audio.loop = true;
    audio.volume = volume;
    audio.muted = muted;
    audioRef.current = audio;
    audio
      .play()
      .catch(() => {
        // 浏览器可能禁止自动播放
      });

    // 卸载时停止
    return () => {
      audio.pause();
      audio.src = ""; 
    };
  }, []);

  // 响应静音切换
  const toggleMute = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.muted = !audio.muted;
    setMuted(audio.muted);
  };

  // 响应滑块调节音量
  const onVolumeChange = (e) => {
    const v = parseFloat(e.target.value);
    setVolume(v);
    if (audioRef.current) {
      audioRef.current.volume = v;
      // 如果用户把音量拖到 0，就自动设为 muted
      if (v === 0) {
        audioRef.current.muted = true;
        setMuted(true);
      } else if (muted) {
        audioRef.current.muted = false;
        setMuted(false);
      }
    }
  };

  return (
    <div style={{ position: "relative", width: "100vw", height: "100vh", overflow: "hidden" }}>
      {/* —— Ocean 背景层 —— */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <style>{`
          .sketchfab-embed-wrapper {
            position: fixed !important;
            top: 0 !important; left: 0 !important;
            width: 100vw !important; height: 100vh !important;
            pointer-events: none !important; z-index: 0 !important;
          }
          .sketchfab-embed-wrapper > iframe {
            position: absolute !important;
            top: 50% !important; left: 50% !important;
            transform: translate(-50%, -50%) scale(1.2) !important;
            min-width: 120% !important; min-height: 120% !important;
            pointer-events: auto !important;
          }
        `}</style>
        <div className="sketchfab-embed-wrapper">
          <iframe
            title="ocean"
            frameBorder="0"
            allow="autoplay; fullscreen; xr-spatial-tracking"
            src="https://sketchfab.com/models/56112ae2e55e45a4951362b323540349/embed?autostart=1&camera=0"
          />
        </div>
      </div>

      {/* —— 飞船小弹窗 —— */}
      <div
        style={{
          position: "fixed",
          bottom: "88px",
          right: "20px",
          width: "64px",
          height: "64px",
          zIndex: 150,
          pointerEvents: "auto",
        }}
      >
        <MiniGLBViewer url="/models/spaceship.glb" />
      </div>

      {/* —— 声音控制按钮 —— */}
      <div
        style={{
          position: "fixed",
          bottom: "20px",  // 刚好在 TabBar 下方
          left: "20px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          zIndex: 200,
          pointerEvents: "auto",
        }}
      >
        <button
          onClick={toggleMute}
          style={{
            background: "rgba(0,0,0,0.3)",
            border: "none",
            borderRadius: "4px",
            padding: "8px",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {muted ? <FiVolumeX size={20}/> : <FiVolume2 size={20}/>}
        </button>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={muted ? 0 : volume}
          onChange={onVolumeChange}
          style={{
            width: "100px",
            background: "rgba(255,255,255,0.2)",
            cursor: "pointer",
          }}
        />
      </div>

      {/* —— UI 层 —— */}
      <div
        style={{
          position: "relative",
          zIndex: 100,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        {children}
      </div>
    </div>
  );
}
